<template>
  <div style="padding:15px">
    <q-card bordered class="my-card">
      <q-card-section class="bg-purple-6 text-white">
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="text-h6">Dashboard</div>
          </div>
        </div>
      </q-card-section>

      <q-separator dark inset />

      <q-card-section>

         <div class="row">
           <div class="col-12 col-md-4 frWidget">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-indigo-6 row items-center justify-center">
                  <q-icon name="storefront" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-indigo-4">
                  <span class="frWidgetText1">Produk</span> <br>
                  <span class="frWidgetText2">{{jumlah_produk}}</span>
                </div>
             </div>
           </div>
            <div class="col-12 col-md-4 frWidget ">
              <div class="row shadow-5 frWidgetSub">
                 <div class="col-4 frWidgetSub1 text-center bg-blue-6 row items-center justify-center">
                   <q-icon name="badge" style="font-size:420%; color:white" />
                 </div>
                 <div class="col-8 frWidgetSub2 bg-blue-4">
                   <span class="frWidgetText1">Pelaku Usaha</span> <br>
                   <span class="frWidgetText2">{{jumlah_pelaku}}</span>
                 </div>
              </div>
            </div>
           <div class="col-12 col-md-4 frWidget ">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-light-blue-6 row items-center justify-center">
                  <q-icon name="group" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-light-blue-4">
                  <span class="frWidgetText1">Pengguna</span> <br>
                  <span class="frWidgetText2">{{jumlah_pengguna}}</span>
                </div>
             </div>
           </div>
           <!-- <div class="col-12 col-md-3 frWidget">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-cyan-6 row items-center justify-center">
                  <q-icon name="paid" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-cyan-4">
                  <span class="frWidgetText1">Transaksi</span> <br>
                  <span class="frWidgetText2">Rp. 645.000</span>
                </div>
             </div>
           </div> -->
         </div>
      </q-card-section>
    </q-card>
    <div class="row">
      <div class="col-12 col-md-6 padding1-5">
        <div class="frameChart shadow-2">
          <div id="produkBar"></div>
        </div>
      </div>
      <div class="col-12 col-md-6 padding1-5">
        <div class="frameChart shadow-2">
          <div id="produkPie"></div>
        </div>
      </div>
    </div>




  </div>
</template>

<style>
</style>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'

exportingInit(Highcharts)
export default {
  name: 'HomePage',
  data() {
    return {
        jumlah_produk : '',
        jumlah_pelaku : '',
        jumlah_pengguna : '',
    }
  },
  methods: {

    getJumlahProduk : function(){
        fetch(this.$store.state.url.URL_BERANDA + "produk", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              this.jumlah_produk = res_data.data[0].jumlah_produk;
        });
      },

    getJumlahPelaku : function(){
        fetch(this.$store.state.url.URL_BERANDA + "pelaku", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              this.jumlah_pelaku = res_data.data[0].jumlah_pelaku;
        });
      },

    getJumlahPengguna : function(){
        fetch(this.$store.state.url.URL_BERANDA + "pengguna", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              this.jumlah_pengguna = res_data.data[0].jumlah_pengguna;
        });
      },

      getProdukPie: function() {
        fetch(this.$store.state.url.URL_BERANDA + "produkPie", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
        })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
            this.produk = res_data.data;
             console.log(this.produk);

             var produk = [];
             var hasil = this.produk;

             for(var i in hasil) {
               produk.push({"name" : hasil[i].uraian, "y" : hasil[i].jumlah_produk});

             }

             console.log(produk);


             this.produkPie(produk);
          });
    },
    
    getProdukBar: function() {
        fetch(this.$store.state.url.URL_BERANDA + "produkBar", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
        })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
            this.produk = res_data.data;
             console.log(this.produk);

             var produk = [];
             var hasil = this.produk;

             for(var i in hasil) {
               produk.push({"name" : hasil[i].nama, "y" : hasil[i].jumlah_produk});

             }

             console.log(produk);


             this.produkBar(produk);
          });
    },
  
    produkBar : function(produk){
      Highcharts.chart('produkBar', {
          chart: {
              type: 'column'
          },
          title: {
              align: 'center',
              text: 'Jumlah Produk Berdasarkan Pelaku UMKM'
          },
          subtitle: {
              align: 'center',
              text: 'Pasar Digital Marina Market Place'
          },
          accessibility: {
              announceNewData: {
                  enabled: true
              }
          },
          xAxis: {
              type: 'category'
          },
          yAxis: {
              title: {
                  text: 'Jumlah Produk'
              }

          },
          legend: {
              enabled: false
          },
          plotOptions: {
              series: {
                  borderWidth: 0,
                  dataLabels: {
                      enabled: true,
                      format: '{point.y:.0f}'
                  }
              }
          },

          tooltip: {
              headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b> Produk<br/>'
          },

          series: [
              {
                  name: 'Jumlah',
                  colorByPoint: true,
                  data: produk
              }
          ],
          drilldown: {
              breadcrumbs: {
                  position: {
                      align: 'right'
                  }
              },
              series: [
                  {
                      name: 'Jumlah',
                      data: produk
                  }
              ]
          }
      });
    },

    produkPie : function(produk) {
      // Create the chart
      Highcharts.chart('produkPie', {
          chart: {
              type: 'pie'
          },
          title: {
              text: 'Jumlah Produk Berdasarkan Kategori',
              align: 'center'
          },
          subtitle: {
              text: 'Pasar Digital Marina Market Place',
              align: 'center'
          },

          accessibility: {
              announceNewData: {
                  enabled: true
              },
              point: {
                  valueSuffix: '%'
              }
          },

          plotOptions: {
              series: {
                  borderRadius: 5,
                  dataLabels: [{
                      enabled: true,
                      distance: 15,
                      format: '{point.name}'
                  }, {
                      enabled: true,
                      distance: '-30%',
                      filter: {
                          property: 'percentage',
                          operator: '>',
                          value: 5
                      },
                      format: '{point.y:.0f}',
                      style: {
                          fontSize: '0.9em',
                          textOutline: 'none'
                      }
                  }]
              }
          },

          tooltip: {
              headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b> Produk<br/>'
          },

          series: [
              {
                  name: 'Jumlah',
                  colorByPoint: true,
                  data: produk
              }
          ],
          drilldown: {
              series: [
                  {
                      name: 'Jumlah',
                      data: produk
                  }
              ]
          }
      });
    },

  },
  mounted () {
    this.getProdukBar();
    this.getProdukPie();
    this.getJumlahProduk();
    this.getJumlahPelaku();
    this.getJumlahPengguna();
  },
}
</script>
